<div class="flex-header">
  <div class="mat-dialog-title">
    Email Your Username
  </div>
</div>
<div class="flex-content">
  <div>
    Your username will be sent to the email address associated with the information you submitted.
  </div>
  <br>
  <div>
    NOTE: Remember to look in your Junk or Spam folder too.
  </div>
  <br>
  <div style="padding-top:20px;" *ngIf="loginSettings.V10">
    For additional assistance, please contact the {{loginSettings.CountryCode == 'CAN' ? 'division' :
    'district'}}{{loginSettings.ShowLoginAssistanceInfo
    ? ': ' : '.'}}
    <span *ngIf="loginSettings.ShowLoginAssistanceInfo">
        <span
          *ngIf="loginSettings.UsernamePasswordRequestEmail != ''">{{loginSettings.UsernamePasswordRequestEmail}}</span>
        <span
          *ngIf="loginSettings.UsernamePasswordRequestEmail != '' && loginSettings.UsernamePasswordRequestPhone != ''"> or </span>
        <span *ngIf="loginSettings.UsernamePasswordRequestPhone != ''">({{loginSettings.UsernamePasswordRequestPhone.substring(0,3)}}) {{loginSettings.UsernamePasswordRequestPhone.substring(3,6)}}-{{loginSettings.UsernamePasswordRequestPhone.substring(6)}}</span>
      </span>
  </div>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button id="finalizeCloseButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</div>
